import { CORE_VERSION } from "./core-version";
import type { MgbaCore, MgbaFactory } from "./types";

// Served as static files from public/ (see scripts/update-core.mjs), never
// bundled: the core spawns its pthread worker from its own URL and resolves
// mgba.wasm next to it.
const CORE_PATH = `/mgba/${CORE_VERSION}/mgba.js`;

let corePromise: Promise<MgbaCore> | null = null;

// One core per page. The module owns the canvas, SDL input listeners and an
// AudioContext, so instantiating it twice (React StrictMode re-runs effects)
// would fight over all three.
export function loadCore(canvas: HTMLCanvasElement): Promise<MgbaCore> {
  if (!corePromise) {
    corePromise = (async () => {
      // Absolute on purpose: Vite's import analysis wraps dynamic imports in
      // injectQuery(url, "import"), which only skips URLs that don't start
      // with "." or "/". A root-relative path gets "?import" appended, and
      // the dev server then refuses to serve a public/ file as a module.
      const url = new URL(CORE_PATH, location.href).href;
      const mod = (await import(/* @vite-ignore */ url)) as { default: MgbaFactory };
      const core = await mod.default({ canvas });
      await core.FSInit();
      return core;
    })();
    corePromise.catch(() => {
      corePromise = null;
    });
  }
  return corePromise;
}
